module.exports = __webpack_public_path__ + "static/botticelli-ab2af401179e4cd90bb500df035b68cd.jpg";